export default "__VITE_ASSET__BTfBt8ge__"